/* eslint-disable jsx-a11y/label-has-associated-control */
/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { keyEmptyCheck, formatCurrencyWithoutCurrency } from 'aurora-utils/utils';
import { ADGMPanel } from 'aurora-components';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';

const PaymentDetails = ({ classes, breakdown, payNowHanlder }) => {
  const renderDetail = detail => {
    if (isArray(detail) && !isEmpty(detail)) {
      return (
        <div className={classes.paymentDetailContainer}>
          {detail?.map(item => (
            <div key={item} className={classes.paymentDetailItemContainer}>
              <div className={classes.paymentDetailItem}>
                {item?.label}
                {item?.value && (
                  <span>
                    {keyEmptyCheck('AED_amount', {
                      num: formatCurrencyWithoutCurrency(item?.value),
                    })}
                  </span>
                )}
              </div>
              {isArray(item?.subItems) && !isEmpty(item?.subItems) ? (
                <div className={classes.paymentDetailSubItemsContainer}>
                  {item?.subItems.map(subItem => (
                    <div className={classes.paymentDetailSubItem}>
                      <span className={classes.subItemLabel}>{subItem?.label}</span>
                      {subItem?.value && (
                        <span>
                          {keyEmptyCheck('AED_amount', {
                            num: formatCurrencyWithoutCurrency(subItem?.value),
                          })}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <ADGMPanel title={keyEmptyCheck('payment_details')} hasBodyBorder>
      {isArray(breakdown?.details) ? breakdown?.details.map(detail => renderDetail(detail)) : null}
      <div className={classNames(classes.paymentDetailItemContainer, classes.totalPaymentDetailItemContainer)}>
        <div className={classes.paymentDetailItem}>
          {keyEmptyCheck('total_to_be_paid')}
          <span>
            {keyEmptyCheck('AED_amount', {
              num: formatCurrencyWithoutCurrency(breakdown?.totalAmount),
            })}
          </span>
        </div>
      </div>
      <div className={classes.paymentDetailsBtnContainer}>
        <Button variant='contained' className={classes.commonRedBtn} onClick={payNowHanlder}>
          {keyEmptyCheck('pay_now')}
        </Button>
      </div>
    </ADGMPanel>
  );
};

PaymentDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  breakdown: PropTypes.object.isRequired,
  payNowHanlder: PropTypes.func.isRequired,
};

export default PaymentDetails;
